import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ViewChildren,
  QueryList
} from '@angular/core';
import postscribe from 'postscribe';
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {RequestDiscountVoucherComponent} from '../request-discount-voucher/request-discount-voucher.component';
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {loadFareHarborScript} from '../../../../fareharbor-load-script';
import {getCalendarCardHeightCLS} from '../../../../../helpers';

declare var $: any;

export enum BookingType {
  Safari = 1,
  Climb,
  All
}

export class CalendarMode {
  constructor(options?: { selectorText: string; priceInDollars: string; calendarId: string; }) {
    if (options) {
      this.selectorText = options.selectorText;
      this.priceInDollars = options.priceInDollars;
      this.calendarId = options.calendarId;
    }
  }

  selectorText: string;
  priceInDollars: string;
  calendarId: string;
}

@Component({
  selector: 'app-booking-calendar',
  templateUrl: './booking-calendar.component.html',
  styleUrls: ['./booking-calendar.component.css']
})
export class BookingCalendarComponent implements OnInit, OnDestroy, AfterViewInit {

  public BookingType = BookingType;

  @Input() bookingType: BookingType;
  @Input() priceSubject: string;
  @Input() titleString: string;
  @Input() headerColor: string;
  @Input() hasTextShadow: boolean;
  @Input() defaultSelectedCalendarModeIdx: number;
  @Input() calendarModePrompt: string;
  @Input() calendarModes: CalendarMode[];
  @Input() pixelOffset: string;
  @Input() refUrl: string;

  @ViewChildren('calendarTag', {read: ElementRef}) calendarElements: QueryList<ElementRef>;
  modeIndex: number;
  calendarRefreshCount: number;
  getCalendarCardHeightCLS = getCalendarCardHeightCLS;

  private shouldShowModalCallback: () => void;

  loadAPI: Promise<any>;
  modalRef: BsModalRef;

  constructor(private modalService: BsModalService, private router: Router) {
    this.bookingType = BookingType.Safari;
    this.priceSubject = 'person';
    this.titleString = '<TODO>';
    this.headerColor = 'primary';
    this.hasTextShadow = false;
    this.defaultSelectedCalendarModeIdx = 0;
    this.calendarModePrompt = 'Select a party size: ';
    this.calendarModes = [
      {priceInDollars: 'X,XXX', selectorText: 'N/A', calendarId: 'INVALID'}
    ];

    this.loadAPI = new Promise((resolve) => {
      loadFareHarborScript();
      resolve(true);
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!sessionStorage.getItem('previousUrl') && document.referrer.indexOf('fareharbor.com') > -1) {
          // Should pop modal in this case
          console.log('set prev to fareharbor');
          sessionStorage.setItem('previousUrl', document.referrer);
        } else if (sessionStorage.getItem('previousUrl') === document.referrer) {
          sessionStorage.setItem('previousUrl', event.url);
        }
        this.checkIfReturningFromFareharborForMobileBooking();
      });

    this.initExitModalTracking();

    this.modeIndex = this.defaultSelectedCalendarModeIdx;
  }

  ngOnInit() {
    $.HSCore.components.HSShowAnimation.init('.js-animation-link');
  }

  ngOnDestroy() {
    removeEventListener('blur', this.shouldShowModalCallback);
  }

  initializeCalendars() {
    this.calendarRefreshCount = this.calendarModes.length;
    if (this.calendarElements) {
      const calendarArr = this.calendarElements.toArray();
      for (const index in this.calendarModes) {
        if (true) {
          let scriptToApply = '';

          switch (this.bookingType) {
            case BookingType.Safari:
            case BookingType.Climb: {
              scriptToApply = '<script src="https://fareharbor.com/embeds/script/calendar/kopatours/items/'
                + this.calendarModes[index].calendarId + '?fallback=simple&flow=237165&back=' + this.refUrl + '&full-items=yes"><\/script>';
              break;
            }
            case BookingType.All: {
              scriptToApply = '<script src="https://fareharbor.com/embeds/script/items/kopatours?fallback=simple&flow='
                + this.calendarModes[index].calendarId + '"></script>';
              break;
            }
          }

          postscribe(calendarArr[index].nativeElement, scriptToApply, {
            done: () => {
              this.calendarRefreshCount--;
              if (this.calendarRefreshCount <= 0) {
                this.refreshCalendarVisbilities();
              }
            }
          });
        }
      }
    }
  }

  refreshCalendarVisbilities() {
    if (this.calendarElements) {
      const calendarArr = this.calendarElements.toArray();
      for (const index in this.calendarModes) {
        if (true) {
          const bInst = document.getElementById('btn-' + index);
          if (+index === this.modeIndex) {
            if (bInst) {
              bInst.classList.add('active');
            }
            calendarArr[index].nativeElement.style.display = 'block';
          } else {
            if (bInst) {
              bInst.classList.remove('active');
            }
            calendarArr[index].nativeElement.style.display = 'none';
          }
        }
      }
    }
  }

  isMobile() {
    return document.body.clientWidth < 768;
  }

  setMode(idx: number) {
    this.modeIndex = idx;
    this.refreshCalendarVisbilities();
  }

  ngAfterViewInit() {
    this.initializeCalendars();
  }

  openBookingCalendar() {
    document.getElementById('fareharborLink').click();
  }

  initExitModalTracking() {
    this.shouldShowModalCallback = () => {
      setTimeout(() => {
        const modal = document.getElementById('isModalThere');
        if (document.activeElement === document.getElementById('fareharbor-lightframe-iframe') && modal === null) {
          const config: ModalOptions = {
            class: 'modal-lg modal-dialog-centered',
            ignoreBackdropClick: true
          };
          this.modalRef = this.modalService.show(RequestDiscountVoucherComponent, config);
        }
      }, 1000);
    };

    focus();
    addEventListener('blur', this.shouldShowModalCallback);
  }

  checkIfReturningFromFareharborForMobileBooking() {
    if (document.referrer === sessionStorage.getItem('previousUrl') && this.isMobile() && !sessionStorage.getItem('modalShown')) {
      sessionStorage.setItem('modalShown', 'yes');
      const config: ModalOptions = {
        class: 'modal-sm modal-dialog-centered',
        ignoreBackdropClick: true
      };
      setTimeout(() => this.modalRef = this.modalService.show(RequestDiscountVoucherComponent, config), 300);
    }
  }
}
